import { Box } from '@mui/material';
import { FormationsPrimaryButton } from 'components/common/Buttons';

type TAccordionCTA = {
  expanded: boolean | string;
  handleExpand: (value: string) => void;
  completed: number;
  totalStep: number;
  testId: string;
  accordionId: string;
};

export const AccordionCTA = ({
  expanded,
  handleExpand,
  completed,
  totalStep,
  testId,
  accordionId,
}: TAccordionCTA) =>
  expanded ? null : (
    <Box
      sx={{
        width: '100%',
        marginTop: '16px',
      }}
    >
      <FormationsPrimaryButton
        size="large"
        data-testid={testId}
        onClick={() => handleExpand(accordionId)}
      >
        {completed === 0 && "Let's Start"}
        {completed > 0 && completed < totalStep && 'Continue'}
        {completed === totalStep && 'View'}
      </FormationsPrimaryButton>
    </Box>
  );
